import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportUnregisteredComponent } from './report-unregistered.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgApexchartsModule } from 'ng-apexcharts';
import { SelectAcademicYearOnlyModule } from 'src/shared/modules/select-academic-year-only/select-academic-year-only.module';
import { SelectSchoolActivityModule } from 'src/shared/modules/select-school-activity/select-school-activity.module';
import { SelectSchoolLevelRelationV2Module } from 'src/shared/modules/select-school-level-relation-v2/select-school-level-relation-v2.module';
import { SelectSchoolLocationV2Module } from 'src/shared/modules/select-school-location-v2/select-school-location-v2.module';
import { SelectSchoolProgramCategoryModule } from 'src/shared/modules/select-school-program-category/select-school-program-category.module';
import { SelectSchoolProgramModule } from 'src/shared/modules/select-school-program/select-school-program.module';
import { StatusNoDataModule } from 'src/shared/modules/status-no-data/status-no-data.module';
import { PipeModule } from 'src/shared/pipes/pipe.module';



@NgModule({
  declarations: [ReportUnregisteredComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTableModule,
    NgSelectModule,
    SelectAcademicYearOnlyModule,
    SelectSchoolLevelRelationV2Module,
    SelectSchoolLocationV2Module,
    SelectSchoolProgramCategoryModule,
    MatCardModule,
    SelectSchoolProgramModule,
    SelectSchoolActivityModule,
    NgApexchartsModule,
    PipeModule,
    StatusNoDataModule,
  ],
  exports: [ReportUnregisteredComponent],
})
export class ReportUnregisteredModule { }
